import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

@Injectable()
export class ResetPasswordService {
  constructor(private http: HttpClient) {}

  // fetchStateToken(recoveryToken: string): Observable<any> {
  //   return this.http.post(
  //     `${environment.okta.client.url}/api/v1/authn/recovery/token`,
  //     {
  //       recoveryToken,
  //     },
  //   );
  // }

  // setNewPassword(stateToken: string, newPassword: string): Observable<any> {
  //   return this.http.post(
  //     `${environment.okta.client.url}/api/v1/authn/credentials/reset_password`,
  //     {
  //       stateToken,
  //       newPassword,
  //     },
  //   );
  // }
}
